<template>
    <span class="betTicket-liveTag">
        {{ getTranslationBySite('live') }}
    </span>
</template>

<script setup lang="ts">
    import { getTranslationBySite } from '@/libraries/helpers/i18nHelper';
</script>

<style lang="scss" scoped>
@import "@/scss/components/singleMode/betTicketLiveTag";
</style>
